<ng-container *ngIf="empleado; else vacio">
	<div class="emp" [class.sm]="size === 'sm'" [class.is-noname]="!tieneNombre">
		<span class="emp-av">
			<img *ngIf="fotoUrl; else inic" [src]="fotoUrl" alt="" />
			<ng-template #inic>{{ initials }}</ng-template>
		</span>
		<span class="emp-tx">
			<span class="emp-name" [class.is-fallback]="!tieneNombre">{{ mainLine }}</span>
			<span class="emp-mail" *ngIf="subLine">{{ subLine }}</span>
		</span>
		<span class="emp-actions" *ngIf="email">
			<a
				class="emp-btn"
				[href]="mailUrl"
				(click)="$event.stopPropagation()"
				matTooltip="Enviar correo"
				matTooltipPosition="above"
				aria-label="Enviar correo"
				><mat-icon>mail</mat-icon></a
			>
			<a
				class="emp-btn"
				[href]="teamsUrl"
				target="_blank"
				rel="noopener noreferrer"
				(click)="$event.stopPropagation()"
				matTooltip="Chat en Teams"
				matTooltipPosition="above"
				aria-label="Chat en Teams"
				><mat-icon>chat</mat-icon></a
			>
		</span>
	</div>
</ng-container>
<ng-template #vacio>
	<span class="emp-empty">
		<span class="emp-av ph"><mat-icon>person_off</mat-icon></span>
		<span class="emp-empty-tx">{{ emptyText }}</span>
	</span>
</ng-template>
